import * as OrgService from "src/services/orgService";

type NewOrganization = {
  name: string;
  path: string;
  timezoneName: string;
};

export function useCreateOrganization() {
  return async (
    org: NewOrganization
  ): Promise<{ organizationId: string; clientId: string }> => {
    return OrgService.createOrganization(org);
  };
}
